import is from 'is_js';
import { string } from 'yup';

export const encodeUrlParams = (params: Record<string, string>) =>
    new URLSearchParams(params).toString();

export const isExternalURL = (url: string) => {
    let validUrl: URL;

    try {
        validUrl = new URL(url);

        return validUrl.origin !== window.location.origin;
    } catch {
        // if URL is incorrect, it means it is an internal link
        return false;
    }
};

export const validateUrl = (
    str: string,
    errorText: string,
    {
        requiredText = '',
        requireProtocol = false,
    }: {
        requiredText?: string;
        requireProtocol?: boolean;
    } = {},
) => {
    if (!str.length) {
        return requiredText;
    }
    if (requireProtocol && !(str.startsWith('http://') || str.startsWith('https://'))) {
        return errorText;
    }

    if (is.url(str)) {
        return '';
    }

    return errorText;
};
export const isUrl = (str: string) => string().url().isValidSync(str);

export function isNestedPages(url: string): boolean {
    const path = url.split('?')[0];
    const segments = path.split('/').filter(Boolean);

    return segments.length === 4;
}
